module.exports = __webpack_public_path__ + "static/img/eiconfont.6caf142f.svg";